<div class="avaliacao-page">

  <div class="avaliacao-card">

    <div
      class="loading"
      *ngIf="carregando"
    >

      <div class="loading-spinner"></div>

      <span>
        Carregando sua avaliação...
      </span>

    </div>

    <div
      class="erro"
      *ngIf="!carregando && erro"
    >

      <div class="erro-icon">
        !
      </div>

      <span class="erro-label">
        PARAÍSO DO CERRADO
      </span>

      <h2>
        Não foi possível carregar sua avaliação
      </h2>

      <p>
        {{ erro }}
      </p>

      <span class="erro-ajuda">
        Verifique se o link está correto e tente novamente.
      </span>

    </div>

    <ng-container
      *ngIf="
        !carregando &&
        !erro &&
        avaliacao
      "
    >

      <div
        class="formulario"
        *ngIf="!avaliacao.respondidaEm"
      >

        <div class="cabecalho">

          <span class="label">
            PARAÍSO DO CERRADO
          </span>

          <h1>
            Como foi sua experiência?
          </h1>

          <p class="descricao">
            Olá, <strong>{{ avaliacao.nomeHospede }}</strong>!
            <br>
            Queremos saber como foi sua estadia.
          </p>

        </div>

        <div class="resumo">

          <div class="resumo-conteudo">

          <span class="resumo-label">
            SUA ESTADIA:
          </span>

            <strong class="quarto-nome">
              {{ avaliacao.quartoNome }}
            </strong>

            <div class="datas">

              <div class="data">
                <span class="data-label">CHECK-IN: </span>
                <strong>{{ avaliacao.checkIn | date:'dd/MM/yyyy' }}</strong>
              </div>

              <div class="data">
                <span class="data-label">CHECK-OUT: </span>
                <strong>{{ avaliacao.checkOut | date:'dd/MM/yyyy' }}</strong>
              </div>

            </div>

          </div>

        </div>

        <div class="campo-nota">

          <div class="campo-titulo">

            <span>
              Como você avalia sua estadia?
            </span>

            <small *ngIf="nota === 0">
              Selecione uma nota
            </small>

          </div>


          <div
            class="estrelas"
            role="radiogroup"
            aria-label="Avaliação de 1 a 5 estrelas"
          >

            <button
              type="button"
              *ngFor="let estrela of [1, 2, 3, 4, 5]"
              [class.selecionada]="estrela <= nota"
              [attr.aria-label]="estrela + ' estrela' + (estrela > 1 ? 's' : '')"
              [attr.aria-checked]="estrela === nota"
              role="radio"
              (click)="selecionarNota(estrela)"
            >
              <span>
                ★
              </span>
            </button>

          </div>


          <div
            class="nota-selecionada"
            *ngIf="nota > 0"
          >

            <span>
              {{ nota }}
            </span>

            <span>
              de 5 estrelas
            </span>

          </div>

        </div>

        <div class="campo-comentario">

          <label for="comentario">
            Conte um pouco mais
            <span>(opcional)</span>
          </label>

          <textarea
            id="comentario"
            [(ngModel)]="comentario"
            placeholder="O que você achou da sua estadia?"
            maxlength="1000"
            rows="5"
          ></textarea>

          <div class="contador">
            {{ comentario.length }}/1000
          </div>

        </div>

        <button
          type="button"
          class="btn-enviar"
          [disabled]="enviando || nota === 0"
          (click)="enviar()"
        >

          <span
            class="btn-spinner"
            *ngIf="enviando"
          ></span>

          <span>
            {{
              enviando
                ? 'Enviando avaliação...'
                : 'Enviar avaliação'
            }}
          </span>

        </button>


      </div>

      <div
        class="respondida"
        *ngIf="avaliacao.respondidaEm"
      >

        <div class="sucesso-icon">
          ✓
        </div>

        <span class="sucesso-label">
          PARAÍSO DO CERRADO
        </span>

        <h2>
          Esta estadia já foi avaliada
        </h2>

        <p>
          Você já enviou sua avaliação sobre esta estadia.
        </p>

        <span class="sucesso-detalhe">
          Agradecemos por compartilhar sua experiência conosco.
        </span>

      </div>

    </ng-container>

  </div>

</div>
